import React from 'react';

import ListItem from '../containers/ListItem';
import * as productPropTypes from '../../../products/shapes';
import * as shapes from '../../shapes';
import { t } from '../../../../modules/infra/i18n';

const CategoriesList = ({ categories, setProductCategory }) => (
  <div>
    <h3 className="c-heading u-mb-">{t('register:sale.categories_list.title')}</h3>
    <div className="layout">
      {categories.map((item) => (
        <ListItem key={item.id} item={item} color="blue" onClick={setProductCategory(item.id)} />
      ))}
    </div>
  </div>
);
CategoriesList.propTypes = {
  categories: productPropTypes.categories.isRequired,
  setProductCategory: shapes.handler.isRequired,
};

export default CategoriesList;
